import classNames from 'classnames';
import React, { useCallback, useMemo, useRef } from 'react';
import { DropdownTheme, Dropdown as TPADropdown } from 'wix-ui-tpa/cssVars';
import { useConfig } from '../../contexts/config-context';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useError } from '../../field-error';
import { useFieldAttributes } from '../../services/field-attributes';
import { FieldDescriptionWUT } from '../field-description/field-description-wut';
import { FieldErrorWUT } from '../field-error/field-error-wut';
import { FieldLabelWUT } from '../field-label/field-label-wut';
import { classes } from './dropdown-field-wut.st.css';
import { useFocusFieldEvent } from '../../contexts/events-context';
export const DropdownFieldWUT = _ref => {
  let {
    id,
    target,
    value,
    defaultValue,
    error,
    onChange,
    onFocus,
    onBlur,
    options = [],
    required = false,
    label,
    hideLabel = false,
    description,
    placeholder,
    disabled = false,
    readOnly,
    customErrors,
    fieldType,
    className,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const valueByLabel = useMemo(() => options.reduce((result, option) => {
    result[option.label] = option.value;
    return result;
  }, {}), [options]);
  const selectableOptions = useMemo(() => options.map((option, index) => {
    return {
      id: `${id}-opt-${index}`,
      value: option.label,
      isSelectable: true
    };
  }), [options, id]);
  const idByValue = useMemo(() => selectableOptions.reduce((result, option) => {
    result[option.value] = option.id;
    return result;
  }, {}), [selectableOptions]);
  const {
    hasError,
    errorMessage
  } = useError(error, customErrors, fieldType);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const {
    labelId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const dropdownRef = useRef(null);
  useFocusFieldEvent(() => {
    var _dropdownRef$current;
    (_dropdownRef$current = dropdownRef.current) == null || _dropdownRef$current.focus();
  }, id);
  const handleChange = useCallback(option => {
    const optionValue = option.value ? valueByLabel[option.value] : '';
    onChange(optionValue);
  }, [valueByLabel, onChange]);

  // TODO: contribution to WUT needed. Passing undefined as initialSelectedId does not rerender dropdown.
  const initialSelectedId = useMemo(() => value && idByValue[value] || defaultValue && idByValue[defaultValue] || String(Math.random() * Date.now()), [defaultValue, value, idByValue]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId
      // TODO: use id & htmlFor instead of aria-labelledby
      // htmlFor={inputId}
      ,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement("div", {
      onFocus: onFocus,
      onBlur: onBlur,
      "aria-label": required ? 'required' : ''
    }, /*#__PURE__*/React.createElement(TPADropdown
    // TODO: use id & htmlFor instead of aria-labelledby
    // id={inputId}
    , {
      "aria-labelledby": labelId,
      "data-hook": `dropdown-${id}`,
      error: hasError,
      newErrorMessage: true,
      className: classNames(classes.root, classes.theme, {
        [classes.error]: hasError,
        [classes.hover]: forcedHover,
        [classes.mobileDropdown]: isMobile
      }, className),
      placeholder: placeholder,
      disabled: disabled,
      readOnly: readOnly,
      name: label,
      options: selectableOptions,
      key: `${id}-${value}` // to force rerender, remove after contribution to WUT
      ,
      mobileNativeSelect: isMobile,
      initialSelectedId: initialSelectedId,
      onChange: handleChange,
      upgrade: true,
      "aria-label": label,
      theme: DropdownTheme.Box,
      "aria-describedby": ariaDescribedBy,
      "aria-invalid": hasError,
      ref: dropdownRef
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=dropdown-field-wut.js.map